import axios from "../http_v2";

export default {
  // 查看手机号发送验证码
  phone: (params) => {
    return axios.post("opservice/tenant/security/smscode", params);
  },
  // 查看手机号-验证完登录
  valid: (params) => {
    return axios.post("opservice/tenant/security/smscode/valid", params);
  },
  hidefield: (data) => {
    return axios.post("opservice/tenantconf/current", data);
  },
  form: {
    list: (params) => {
      return axios.post("formbuilder/applyform/page", params);
    },
    info: (params) => {
      return axios.get("formbuilder/applyform/get/" + params.id, params);
    },
  },
  norepeart: {
    page: (params) => {
      return axios.get("formbuilder/cluedistinctsetting/page", params);
    },
    save: (params) => {
      return axios.post("formbuilder/cluedistinctsetting/save", params);
    },
    enabled: (params) => {
      return axios.post("formbuilder/cluedistinctsetting/enabled", params);
    },
    del: (params) => {
      return axios.post("formbuilder/cluedistinctsetting/delete", params);
    },
  },
  clue: {
    toCrmSetSave: (params) => {
      return axios.post("formbuilder/tocrmcustomesetting/save", params);
    },
    toCrmSetDel: (params) => {
      return axios.post("formbuilder/tocrmcustomesetting/delete", params);
    },
    toCrmSetList: (params) => {
      return axios.get("formbuilder/tocrmcustomesetting/page", params);
    },
    toCrmSync: (params) => {
      return axios.post("formbuilder/tocrmcustomesetting/enabled", params);
    },
  },
  // 渠道分类
  channel: {
    tree: (params) => {
      // 获取渠道分类+子集渠道名称
      return axios.post("marketcenter/urlChannel/page/channelTemplate", params);
    },
    typelist: (params) => {
      return axios.get("marketcenter/urlChannel/page/channelType", params);
    },
    options: (params) => {
      return axios.post("marketcenter/urlChannel/page/channelTemplate", params);
    },
    page: (params) => {
      return axios.post("formbuilder/formbuild/channel/page", params);
    },
    save: (params) => {
      return axios.post("formbuilder/formbuild/channel/save", params);
    },
  },
  // 获取组织树
  getOrgs: (params) => {
    return axios.post("opservice/org/tree", params);
  },
  getpage: (params) => {
    return axios.get("formbuilder/tocrmorg/page", params);
  },
  getorgid: (params) => {
    return axios.get("formbuilder/tocrmorg/getbyorgid", params);
  },
  orgsave: (params) => {
    return axios.post("formbuilder/tocrmorg/save", params);
  },
  orgdel: (params) => {
    return axios.post("formbuilder/tocrmorg/delete", params);
  },

  // cc组织设置
  cc: {
    getpage: (params) => {
      return axios.get("formbuilder/toccorg/page", params);
    },
    getorgid: (params) => {
      return axios.get("formbuilder/toccorg/getbyorgid", params);
    },
    orgsave: (params) => {
      return axios.post("formbuilder/toccorg/save", params);
    },
    orgdel: (params) => {
      return axios.post("formbuilder/toccorg/delete", params);
    },
  },
  // 按字段合并导出
  mergeExport: (params) => {
    return axios.post("formbuilder/applyform/merge/export", params);
  },
  // 获取下载中心列表
  getDownloadlist: (params) => {
    return axios.get(
      "opservice/ansyctask/list?pageNum=" +
        params.pageNum +
        "&pageSize=" +
        params.pageSize,
      params
    );
  },
  menuList: (params) => {
    return axios.get("opservice/tenant/security/current/menu/left", params);
  },
  syncBtn: (params) => {
    return axios.get("formbuilder/tocrm/hand?sid=" + params);
  },
  //勾选线索同步至urm
  urmchecked: (params) => {
    return axios.get("formbuilder/tocrm/setting?state=" + params);
  },
  //点击同步规则tab页
  syncTabs: (params) => {
    return axios.get("formbuilder/tocrm/get/setting", params);
  },
  uploadApi: {
    uploadImg:
      process.env.VUE_APP_API_ROOT + "opservice/ophonoredguest/savefile",
  },
  // 保存或者更新表单信息
  saveForm: (params) => {
    return axios.post("formbuilder/applyform/save", params);
  },
  // 获取单个表单信息
  getFormInfo: (params) => {
    return axios.get("formbuilder/applyform/get/" + params);
  },
  // 更改状态
  updateStatus: (params) => {
    return axios.post(
      "formbuilder/applyform/update/status?id=" +
        params.id +
        "&status=" +
        params.status
    );
  },
  // 获取表单列表
  getFormList: (params) => {
    return axios.post("formbuilder/applyform/page", params);
  },
  // 删除表单
  deleteForm: (params) => {
    return axios.post("formbuilder/applyform/remove?id=" + params);
  },
  // 获取渠道类型
  typeList: (params) => {
    return axios.get("marketcenter/urlChannel/get/channelType", params);
  },
  // 获取渠道信息
  channelInfoList: (params) => {
    return axios.post("marketcenter/urlChannel/list/channelTemplate", params);
  },
  // 生成渠道地址
  addChannel: (params) => {
    return axios.post("marketcenter/urlChannel/add/channel", params);
  },
  // 获取表单推广的渠道信息
  getChannelList: (params) => {
    return axios.post("marketcenter/urlChannel/list/channel", params);
  },
  // 获取国内城市列表
  cityList: () => {
    return axios.get("opservice/opbasedocarea/allcity.json");
  },
  // 获取国外城市列表
  outCityList: () => {
    return axios.get("opservice/opbasedocarea/allcityAbroad.json");
  },
  // 保存或者更新分派规则
  saveApplyFormRule: (params) => {
    return axios.post("formbuilder/applyformrule/save", params);
  },
  // 组织结构接口
  orgTree: (params) => {
    return axios.post("opservice/org/tree/all", params);
  },
  // 获取分派规则列表
  getRuleList: (params) => {
    return axios.post("formbuilder/applyformrule/page", params);
  },
  // 删除表单
  deleteRule: (params) => {
    return axios.post("formbuilder/applyformrule/remove?id=" + params);
  },
  // 获取线索列表
  getSubmitClueList: (params) => {
    return axios.post("formbuilder/applyFormSubmit/page", params);
  },
  // 手动分派
  handAssign: (params) => {
    return axios.post("formbuilder/applyFormSubmit/approtion", params);
  },
  // 收回分派
  recoverAssign: (params) => {
    return axios.post("formbuilder/applyFormSubmit/recover?id=" + params);
  },
  // 线索详情
  getClueDetail: (params) => {
    return axios.post("formbuilder/applyFormSubmit/get?id=" + params);
  },
  // 线索详情带有邮件发送记录
  getClueDetailWithEmailLog: (params) => {
    return axios.post(
      "formbuilder/applyFormSubmit/get/withemaillog?id=" + params
    );
  },
  // 管理员填写提交
  submitClueInfo: (params) => {
    return axios.post("formbuilder/applyFormSubmit/manager/save", params);
  },
  // 导出表单数据
  exportForm: (params) => {
    return axios.post("formbuilder/applyFormSubmit/export?formId=" + params);
  },
  // 渠道树
  channelTree: (params) => {
    return axios.post(
      "marketcenter/urlChannel/list/relateion/channelTemplate",
      params
    );
  },
  getSendSetting: (params) => {
    return axios.get("formbuilder/applyformrule/get/notice/setting", params);
  },
  sendSetting: (params) => {
    return axios.get(
      "formbuilder/applyformrule/notice/setting?issend=" + params
    );
  },
  // 线索发送
  sendEmail: (params) => {
    return axios.post("formbuilder/applyFormSubmit/send/salesman", params);
  },
  // 导出我的线索
  exportAll: (params) => {
    return axios.post("formbuilder/applyFormSubmit/export/page", params);
  },
  getFilePath: (params) => {
    return axios.get("formbuilder/upload/html/page/get", params);
  },
};
